import { darkstyle } from "./gm-darkstyle";
import { grayscale } from "./gm-grayscale";

export class NetiaGoogleMap {
	constructor(mapNode) {
		this.invest = false;
		this.mapNode = mapNode;
		this.mapMarkers = [];
		this.mapMarkersVisible = [];
		this.mapActiveWindow = null;
		this.mapSettings = {
			center: {
				lat: 51.806634,
				lng: 19.2037383,
			},
			zoom: {
				start: 5.52,
				small: 6,
				big: 10,
				sbig: 14,
			},
		};
		this.posTypes = {};
		this.initMap();
		this.changeStyle();
	}

	initMap() {
		this.map = new google.maps.Map(this.mapNode, {
			zoom: this.mapSettings.zoom.start,
			center: this.mapSettings.center,
			mapTypeControl: false,
			style: grayscale,
		});
	}

	initMarkers(data) {
		for (let i = 0; i < data.length; i++) {
			this.genereteMarker(data[i]);
		}
	}

	genereteMarker(markerData, i) {
		const markerLatlng = {
			lat: markerData.latitude,
			lng: markerData.longitude,
		};

		this.invest = this.mapNode.hasAttribute("data-pos-invest");
		if (this.invest) {
			const marker = new google.maps.Marker({
				latitude: markerData.latitude,
				longitude: markerData.longitude,
				position: markerLatlng,
				map: this.map,
				icon: this.posTypes[markerData.type].icon,
				title: markerData.title,
				type: markerData.type,
				city: markerData.city,
				id: markerData.id,
				subtitle: markerData.subtitle,
				contactLabel: markerData.contactLabel,
			});

			this.mapMarkers.push(marker);
			this.mapMarkersVisible.push(marker);

			// add click events & set infowindows
			google.maps.event.addListener(
				marker,
				"click",
				((marker, i) => {
					return () => {
						// const opening = (objsArr) => {
						// 	let str = ''
						// 	for (let i = 0; i < objsArr.length; i++) {
						// 		let obj = objsArr[i]
						// 		str += `<p>${obj.days} <strong>${obj.val}</strong></p>`
						// 	}
						// 	return str
						// }
						let contentString =
							`<div class="pos__infowin pos__infowin--invest" tabindex="-1">` +
							`<div class="map-infowin__content">` +
							`<h3>${markerData.title}</h3>` +
							`<p>${markerData.subtitle}</p>`;
						// opening(markerData.opening);
						if (markerData.phone.length > 0) {
							contentString +=
								`<p class="map-infowin__label">${markerData.contactLabel}</p>` +
								`<p class="map-infowin__phone">Telefon: <span>`;
							for (let i = 0; i < markerData.phone.length; i++) {
								contentString += `<a class="info-base__btnlink" href="tel:${markerData.phone[i]}">${markerData.phone[i]}</a>`;
								if (i < markerData.phone.length - 1) {
									contentString += `, `;
								}
							}
							contentString += `</span></p>`;
						}

						// contentString += `<ul class="pos__infowin__btns">`;
						if (markerData.phone.length > 0) {
							contentString += `<a href="tel:${markerData.phone[0]}" class="info-base__btnlink map-infowin__link">Zadzwoń</a>`;
						}

						let infowindow = new google.maps.InfoWindow({
							content: contentString,
						});
						let infowindowZoom = this.mapSettings.zoom.sbig;
						// console.log('this.map.getZoom()', this.map.getZoom());
						if (this.map.getZoom() > this.mapSettings.zoom.sbig) {
							infowindowZoom = this.map.getZoom();
						}

						this.showPosition(infowindowZoom, {
							lat: markerData.latitude,
							lng: markerData.longitude,
						});

						//Close active window if exists
						if (this.mapActiveWindow != null) this.mapActiveWindow.close();

						infowindow.open(this.map, marker);
						// //Store new window in a variable
						this.mapActiveWindow = infowindow;

						// google.maps.event.addListener(infowindow, 'domready', () => {
						// 	let iwWindow = document.querySelector('.gm-style-iw');
						// 	iwWindow.parentElement.firstChild.style.display = 'none';
						// 	iwWindow.classList.add('on');
						// });
					};
				})(marker, i)
			);
		} else {
			const marker = new google.maps.Marker({
				latitude: markerData.latitude,
				longitude: markerData.longitude,
				position: markerLatlng,
				map: this.map,
				icon: this.posTypes[markerData.type].icon,
				title: markerData.name,
				type: markerData.type,
				city: markerData.city,
				address: markerData.address,
				id: markerData.id,
			});

			this.mapMarkers.push(marker);
			this.mapMarkersVisible.push(marker);

			// add click events & set infowindows
			google.maps.event.addListener(
				marker,
				"click",
				((marker, i) => {
					return () => {
						const opening = (objsArr) => {
							let str = "";
							for (let i = 0; i < objsArr.length; i++) {
								let obj = objsArr[i];
								str += `<p>${obj.days} <strong>${obj.val}</strong></p>`;
							}
							return str;
						};
						let contentString =
							`<div class="pos__infowin" tabindex="-1">` +
							`<div class="map-infowin__content">` +
							`<h3>${markerData.name}<br>${markerData.address}</h3>` +
							opening(markerData.opening);
						if (markerData.phone.length > 0) {
							contentString += `<p>Telefon: <span>`;
							for (let i = 0; i < markerData.phone.length; i++) {
								contentString += `<a class="info-base__btnlink" href="tel:${markerData.phone[i]}">${markerData.phone[i]}</a>`;
								if (i < markerData.phone.length - 1) {
									contentString += `, `;
								}
							}
							contentString += `</span></p>`;
						}

						contentString += `<ul class="pos__infowin__btns">`;
						if (markerData.phone.length > 0) {
							contentString += `<li><a href="tel:${markerData.phone[0]}" class="info-base__btnlink">Zadzwoń</a></li>`;
						}
						contentString +=
							`<li><a href="https://www.google.pl/maps/dir//${markerData.address}" target="_blank" class="info-base__btnlink">Wyznacz trasę <span class="sr-only">otwiera się w nowej karcie</span></a></li>` +
							`</ul>` +
							`</div>` +
							`</div>`;

						let infowindow = new google.maps.InfoWindow({
							content: contentString,
						});
						let infowindowZoom = this.mapSettings.zoom.sbig;
						// console.log('this.map.getZoom()', this.map.getZoom());
						if (this.map.getZoom() > this.mapSettings.zoom.sbig) {
							infowindowZoom = this.map.getZoom();
						}

						this.showPosition(infowindowZoom, {
							lat: markerData.latitude,
							lng: markerData.longitude,
						});

						//Close active window if exists
						if (this.mapActiveWindow != null) this.mapActiveWindow.close();

						infowindow.open(this.map, marker);
						// //Store new window in a variable
						this.mapActiveWindow = infowindow;

						// google.maps.event.addListener(infowindow, 'domready', () => {
						// 	let iwWindow = document.querySelector('.gm-style-iw');
						// 	iwWindow.parentElement.firstChild.style.display = 'none';
						// 	iwWindow.classList.add('on');
						// });
					};
				})(marker, i)
			);
		}
	}

	openInfoWindow(id) {
		// this.mapMarkers[0].click();
		const marker = this.mapMarkers.filter(function (item) {
			return item.id == id;
		});
		// console.log(marker);
		google.maps.event.trigger(marker[0], "click");
	}

	resetMap() {
		this.showPosition(this.mapSettings.zoom.start, this.mapSettings.center);
		this.filterMarkers([]);
		if (this.mapActiveWindow) {
			this.mapActiveWindow.close();
		}
	}

	showPosition(zoom, pos) {
		this.map.setZoom(zoom);
		this.map.setCenter(pos);
	}

	initPosTypes(data) {
		for (let i = 0; i < data.length; i++) {
			let pos = data[i];
			this.posTypes[pos.id] = {
				name: pos.name,
				icon: pos.icon,
			};
		}
	}

	filterMarkers(filtersArr) {
		this.mapMarkersVisible = [];
		if (!filtersArr.length) {
			for (let i = 0; i < this.mapMarkers.length; i++) {
				const marker = this.mapMarkers[i];
				marker.setVisible(true);
				this.mapMarkersVisible.push(marker);
			}
			return;
		}
		for (let i = 0; i < this.mapMarkers.length; i++) {
			const marker = this.mapMarkers[i];
			if (filtersArr.length) {
				if (filtersArr.indexOf(marker.type) > -1) {
					marker.setVisible(true);
					this.mapMarkersVisible.push(marker);
				} else {
					marker.setVisible(false);
				}
			}
		}
	}

	filterMarkersInLocalization(localization, distance_limit) {
		this.mapMarkersVisible = [];
		const latLngBounds = new google.maps.LatLngBounds();
		for (let i = 0; i < this.mapMarkers.length; i++) {
			const marker = this.mapMarkers[i];
			// console.log(marker.position.lat());
			// console.log(google.maps.geometry.spherical.computeDistanceBetween(new google.maps.LatLng(marker.position.lat(), marker.position.lng()), localization));
			const position = new google.maps.LatLng(
				marker.position.lat(),
				marker.position.lng()
			);
			const distance = google.maps.geometry.spherical.computeDistanceBetween(
				position,
				localization
			);
			// console.log(distance, distance_limit);
			if (distance <= distance_limit) {
				marker.setVisible(true);
				this.mapMarkersVisible.push(marker);
				latLngBounds.extend(position);
			} else {
				// marker.setVisible(false); // clear points outside localization
			}
		}
		// console.log(this.mapMarkersVisible);
		if (this.mapMarkersVisible.length > 0) {
			this.showPosition(15, localization);
			this.map.fitBounds(latLngBounds);
			this.decreaseZoom();
		}
		return this.mapMarkersVisible.length;
	}

	filterMarkersInCity(city) {
		this.mapMarkersVisible = [];
		const latLngBounds = new google.maps.LatLngBounds();
		for (let i = 0; i < this.mapMarkers.length; i++) {
			const marker = this.mapMarkers[i];
			// console.log(marker.city);
			const position = new google.maps.LatLng(
				marker.position.lat(),
				marker.position.lng()
			);
			if (marker.city == city) {
				marker.setVisible(true);
				this.mapMarkersVisible.push(marker);
				latLngBounds.extend(position);
			} else {
				// marker.setVisible(false)
			}
		}
		this.map.fitBounds(latLngBounds);
		this.decreaseZoom();
	}

	decreaseZoom() {
		this.map.setZoom(this.map.getZoom() - 1);
		if (this.map.getZoom() > 17) {
			this.map.setZoom(17);
		}
	}
	setMapOnAll(map) {
		for (var i = 0; i < this.mapMarkers.length; i++) {
			this.mapMarkers[i].setMap(map);
		}
	}

	// Removes the markers from the map, but keeps them in the array.
	clearMarkers() {
		this.setMapOnAll(null);
	}

	// Shows any markers currently in the array.
	showMarkers() {
		this.setMapOnAll(this.map);
	}

	// Deletes all markers in the array by removing references to them.
	deleteMarkers() {
		if (markerCluster) {
			// console.log(markerCluster);
			// markerCluster.setMap(null);
			markerCluster.clearMarkers();
		}

		clearMarkers();
		markers = [];
	}

	//Change style of map to darker by "contrast"
	changeStyle() {
		let isContrast = localStorage.getItem("contrast");
		const contrastButton = document.querySelector('[data-action="contrast"]'),
			setStyle = (check) => {
				this.map.setOptions({
					styles: check ? darkstyle : grayscale,
				});
			};

		setInterval(() => {
			if (this.checkContrast()) setStyle(this.checkContrast());
			else setStyle(isContrast);
		}, 1000);

		contrastButton.addEventListener("click", (el) => {
			if (!this.checkContrast()) {
				isContrast = localStorage.getItem("contrast");
				setStyle(isContrast);
			}
		});
	}

	//Check manual contrast mode
	checkContrast() {
		const trigger = document.querySelector("body"),
			triggerColor = window.getComputedStyle(trigger).color;

		if (triggerColor === "rgb(255, 255, 255)") return true;

		return false;
	}
}
